import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import atob from "atob";
import { formatDate } from "../../formatDate";
import "./style.scss";
import { useAppContext } from "../../../AppContext";

const Navbar = () => {
  const { user } = useAppContext();
  const location = useLocation();

  const matchPath = useMemo(() => {
    const parts = location.pathname.split("/");
    return parts.length > 2 ? `/${parts[1]}/${parts[2]}` : "/app";
  }, [location.pathname]);

  const menu = useMemo(
    () => [
      {
        name: "Account",
        icon: "user-circle",
        path: "/app/account",
        // path: (matchPath === "/" ? "/app" : matchPath) + "/account",
      },
      {
        name: "Logout",
        icon: "sign-out-alt",
        path: "/login",
        method: () => {
          localStorage.clear();
          sessionStorage.clear();
        },
      },
    ],
    [matchPath]
  );

  return (
    <nav className="navbar-container">
      <div>
        {user.data ? (
          <div className="brand">
            <h1 className="elems id">
              Welcome,{" "}
              <span>
                {user.data.usrKey
                  ? JSON.parse(atob(user.data.usrKey)).username
                  : ""}
              </span>
              !
            </h1>
            <h1 className="elems date">
              {formatDate.long(new Date().getTime() / 1000)}
            </h1>
          </div>
        ) : (
          <div />
        )}
      </div>
      <ul className="navLink">
        {menu.map((menuItem, key) => (
          <li key={key}>
            <Link
              to={menuItem.path}
              onClick={() => menuItem.method && menuItem.method()}
              className="link"
            >
              <FontAwesomeIcon className="icon" icon={["fas", menuItem.icon]} />
              {menuItem.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
